import { useEffect, useState } from "react"

import dayjs from "dayjs";

import {
    // styled,
    // Card,
    Grid,
    // Stack,
    Button,
    Box,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    // Typography,
    // Dialog,
    // DialogActions,
    // DialogContent,
    // DialogTitle,
    // RadioGroup,
    // FormControlLabel,
    // Radio,
    TextField,
    Divider,
    // FormControl,
    // Select,
    // MenuItem,
    // Checkbox,
    // ListItemText,
    // FormHelperText,
    // InputLabel
} from '@mui/material';

import { useFormik } from 'formik';

import { useAppContextFeatures } from "../../../../../context/AppContext"

import { initialValues, validationSchema } from "../../../schema/reports/productsReportSchema"

import DatePickerComponent from "../../../../../components/common/DatePickerComponent"

import { useReports } from "../../../../../hooks/api/useReports";

import { useTranslations } from '../../../../../hooks/useTranslations';

import { productInjectionFields, productLoadStatusTypes } from "../../../hooks/model/useProduct"

export function ProductsReportFilters(props) {

    const { t } = useTranslations({ ns: ["common", "_@report", "_@products", "_common"] })

    const {
        state,
        dispatch,
        actionTypes,
        // filterType
    } = props

    const columns = [
        { accessorKey: 'id', header: 'Id', size: 70, sortable: true },
        { accessorKey: `${productInjectionFields.checkinDateTime.retrieveKey}`, header: t('checkedInAt'), size: 170 },
        { accessorKey: 'ax_createdatetime', header: t('createdDateTime'), size: 170 },

        { accessorKey: productInjectionFields.customerMarking.retrieveKey, header: t('marking'), size: 150 },
        { accessorKey: productInjectionFields.companyPurchaseNumber.retrieveKey, header: t('companyPNo'), size: 120 },
        { accessorKey: 'concatItemDescription', header: t("description"), size: 100 },
        { accessorKey: 'totalCbm', header: t("tCbm"), size: 120 },
        { accessorKey: 'totalPackQty', header: t("packUnit"), size: 120 },

        { accessorKey: productInjectionFields.supplierName.retrieveKey, header: t('supplierName'), size: 120 },
        { accessorKey: productInjectionFields.supplierPurchaseNumber.retrieveKey, header: t('supplierPNo'), size: 120 },
        { accessorKey: productInjectionFields.courierTrackingNo.retrieveKey, header: t('courierNo'), size: 120 },

        { accessorKey: productInjectionFields.prepayTransportFee.retrieveKey, header: t('payFreight'), size: 130 },

        { accessorKey: productInjectionFields.signedByUserDisplay.retrieveKey, header: t('signedBy'), size: 110 },
        { accessorKey: productInjectionFields.remark.retrieveKey, header: t('remark'), size: 120 },

        { accessorKey: 'totalWeight', header: t("tWeight"), size: 120 },

        {
            accessorKey: productInjectionFields.loadStatus.retrieveKey,
            header: t('loadStatus'),
            size: 120,
            Cell: ({ renderedCellValue, row }) => {
                // let loadStatus = row[productInjectionFields.loadStatus.retrieveKey]
                return `${t(renderedCellValue)}`
            }
        },

        { accessorKey: `load_container_id`, header: t('containerNo'), size: 160 },
        { accessorKey: 'ax_createusername', header: t('createdBy'), size: 120 },
    ]

    const { filterOperatorTypes } = useReports({});

    const { closeCustomDrawer } = useAppContextFeatures()

    const onSubmit = () => {

        handleApply()

    }

    const check = (name, operator = '', defaultValue = '') => {

        let valid;

        if (operator) {
            valid = state.rules.find(i => i.name === name && i.operator === operator)
        } else {
            valid = state.rules.find(i => i.name === name)
        }

        if (valid) return valid.value

        return defaultValue
    }

    let mergeValues = {
        ...initialValues,
    }

    // console.log('check("ax_createdatetime", filterOperatorTypes.moreThanEq)', check("ax_createdatetime", filterOperatorTypes.moreThanEq))

    if (check("ax_createdatetime", filterOperatorTypes.moreThanEq)) {
        mergeValues = { ...mergeValues, createDate: { ...mergeValues.createDate, from: dayjs(check("ax_createdatetime", filterOperatorTypes.moreThanEq)) } }
    }

    if (check("ax_createdatetime", filterOperatorTypes.lessThanEq)) {
        mergeValues = { ...mergeValues, createDate: { ...mergeValues.createDate, to: dayjs(check("ax_createdatetime", filterOperatorTypes.lessThanEq)) } }
    }

    if (check(productInjectionFields.checkinDateTime.retrieveKey, filterOperatorTypes.moreThanEq)) {
        mergeValues = { ...mergeValues, checkInDate: { ...mergeValues.checkInDate, from: dayjs(check(productInjectionFields.checkinDateTime.retrieveKey, filterOperatorTypes.moreThanEq)) } }
    }

    if (check(productInjectionFields.checkinDateTime.retrieveKey, filterOperatorTypes.lessThanEq)) {
        mergeValues = { ...mergeValues, checkInDate: { ...mergeValues.checkInDate, to: dayjs(check(productInjectionFields.checkinDateTime.retrieveKey, filterOperatorTypes.lessThanEq)) } }
    }

    if (check(productInjectionFields.customerMarking.retrieveKey, filterOperatorTypes.eq)) {
        mergeValues = { ...mergeValues, customerMarking: check(productInjectionFields.customerMarking.retrieveKey, filterOperatorTypes.eq) }
    }

    if (check(productInjectionFields.supplierName.retrieveKey, filterOperatorTypes.eq)) {
        mergeValues = { ...mergeValues, supplierName: check(productInjectionFields.supplierName.retrieveKey, filterOperatorTypes.eq) }
    }

    if (check(productInjectionFields.supplierPurchaseNumber.retrieveKey, filterOperatorTypes.eq)) {
        mergeValues = { ...mergeValues, supplierPurchaseNumber: check(productInjectionFields.supplierPurchaseNumber.retrieveKey, filterOperatorTypes.eq) }
    }

    if (check(productInjectionFields.loadStatus.retrieveKey, filterOperatorTypes.eq)) {
        mergeValues = { ...mergeValues, loadStatus: check(productInjectionFields.loadStatus.retrieveKey, filterOperatorTypes.eq) }
    }

    // console.log('mergeValues', state, mergeValues)

    const formik = useFormik({
        initialValues: mergeValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleSubmit, handleChange, setFieldValue } = formik;

    const RenderMainForm = () => {
        return (
            <Box
                sx={{
                    p: 2
                }}
            >
                {/* {JSON.stringify(errors)}
                {JSON.stringify(values)} */}
                <Grid container spacing={1}>

                    <Grid item sm={12} xs={12} md={6}>
                        <DatePickerComponent
                            sx={{
                                width: '100%'
                            }}
                            autoFocus={Boolean(true)}
                            config={{
                                name: "createDate.from",
                                hasError: Boolean(errors?.createDate?.from),
                                helperText: errors?.createDate?.from,
                                label: t("createDateFrom"),
                                renderValue: ({ values }) => {
                                    return values.createDate.from
                                }
                            }}
                            formik={{
                                values,
                                errors,
                                touched,
                                handleChange,
                                setFieldValue
                            }}
                        />
                    </Grid>

                    <Grid item sm={12} xs={12} md={6}>
                        <DatePickerComponent
                            sx={{
                                width: '100%'
                            }}
                            autoFocus={Boolean(false)}
                            config={{
                                name: "createDate.to",
                                hasError: Boolean(errors?.createDate?.to),
                                helperText: errors?.createDate?.to,
                                label: t("createDateTo"),
                                renderValue: ({ values }) => {
                                    return values.createDate.to
                                }
                            }}
                            formik={{
                                values,
                                errors,
                                touched,
                                handleChange,
                                setFieldValue
                            }}
                        />
                    </Grid>

                    <Grid item sm={12} xs={12} md={6}>
                        <DatePickerComponent
                            sx={{
                                width: '100%'
                            }}
                            autoFocus={Boolean(false)}
                            config={{
                                name: "checkInDate.from",
                                hasError: Boolean(errors?.checkInDate?.from),
                                helperText: errors?.checkInDate?.from,
                                label: t("checkedInAtFrom"),
                                renderValue: ({ values }) => {
                                    return values.checkInDate.from
                                }
                            }}
                            formik={{
                                values,
                                errors,
                                touched,
                                handleChange,
                                setFieldValue
                            }}
                        />
                    </Grid>

                    <Grid item sm={12} xs={12} md={6}>
                        <DatePickerComponent
                            sx={{
                                width: '100%'
                            }}
                            autoFocus={Boolean(false)}
                            config={{
                                name: "checkInDate.to",
                                hasError: Boolean(errors?.checkInDate?.to),
                                helperText: errors?.checkInDate?.to,
                                label: t("checkedInAtTo"),
                                renderValue: ({ values }) => {
                                    return values.checkInDate.to
                                }
                            }}
                            formik={{
                                values,
                                errors,
                                touched,
                                handleChange,
                                setFieldValue
                            }}
                        />
                    </Grid>

                    <Grid item sm={12} xs={12} md={12}>
                        <Divider sx={{ mt: 1, mb: 1 }} />
                    </Grid>

                    <Grid item sm={12} xs={12} md={6}>
                        <TextField
                            margin="dense"
                            size="small"
                            fullWidth
                            name={"customerMarking"}
                            label={t("customerMarking")}
                            type="text"
                            variant="outlined"
                            value={values.customerMarking}
                            onChange={handleChange}
                            error={Boolean(errors?.customerMarking)}
                            helperText={errors?.customerMarking}
                        />
                    </Grid>

                    <Grid item sm={12} xs={12} md={6}>
                        <TextField
                            margin="dense"
                            size="small"
                            fullWidth
                            name={"supplierName"}
                            label={t("supplierName")}
                            type="text"
                            variant="outlined"
                            value={values.supplierName}
                            onChange={handleChange}
                            error={Boolean(errors?.supplierName)}
                            helperText={errors?.supplierName}
                        />
                    </Grid>

                    <Grid item sm={12} xs={12} md={6}>
                        <TextField
                            margin="dense"
                            size="small"
                            fullWidth
                            name={"supplierPurchaseNumber"}
                            label={t("supplierPNo")}
                            type="text"
                            variant="outlined"
                            value={values.supplierPurchaseNumber}
                            onChange={handleChange}
                            error={Boolean(errors?.supplierPurchaseNumber)}
                            helperText={errors?.supplierPurchaseNumber}
                        />
                    </Grid>

                    <Grid item sm={12} xs={12} md={6}>
                        <FormControl
                            margin="dense"
                            fullWidth
                            size="small"
                            error={Boolean(errors?.businessId)}
                        >
                            <InputLabel id="loadStatus">{t("loadStatus")}</InputLabel>
                            <Select
                                disabled={values?.differentBusiness === true}
                                labelId="loadStatus"
                                label={t("loadStatus")}
                                name={"loadStatus"}
                                onChange={(event) => {
                                    setFieldValue("loadStatus", event.target.value)
                                }
                                }
                                value={values?.loadStatus}
                                // value={
                                //     checkValueExists({
                                //         dataSearch: dataBusiness,
                                //         valueToCompare: values?.loadStatus
                                //     })
                                // }
                                sx={{
                                    textAlign: 'left'
                                }}
                            >
                                {
                                    Object.keys(productLoadStatusTypes).map((i, index) => {

                                        let item = productLoadStatusTypes[i]

                                        return (
                                            <MenuItem key={index} value={item?.id}>{t(item?.value)}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                            <FormHelperText>
                                {errors?.loadStatus}
                            </FormHelperText>
                        </FormControl>
                    </Grid>

                </Grid>
            </Box>
        )
    }

    const getRule = (props) => ({ ...props })

    const handleApply = () => {

        let filters = []

        if (values?.customerMarking) {
            filters.push(getRule({
                // name: "repo_number",
                name: productInjectionFields.customerMarking.retrieveKey,
                nameDisplay: "Customer Marking",
                operator: filterOperatorTypes.eq,
                value: values?.customerMarking,
                valueDisplay: values?.customerMarking
            }))
        }

        if (values?.supplierName) {
            filters.push(getRule({
                // name: "supplier_name",
                name: productInjectionFields.supplierName.retrieveKey,
                nameDisplay: "Supplier Name",
                operator: filterOperatorTypes.eq,
                value: values?.supplierName,
                valueDisplay: values?.supplierName
            }))
        }

        if (values?.supplierPurchaseNumber) {
            filters.push(getRule({
                // name: "supplier_purchase_number",
                name: productInjectionFields.supplierPurchaseNumber.retrieveKey,
                nameDisplay: "Supplier PNo.",
                operator: filterOperatorTypes.eq,
                value: values?.supplierPurchaseNumber,
                valueDisplay: values?.supplierPurchaseNumber
            }))
        }

        if (values?.loadStatus) {
            filters.push(getRule({
                // name: "supplier_purchase_number",
                name: productInjectionFields.loadStatus.retrieveKey,
                nameDisplay: "Load Status",
                operator: filterOperatorTypes.eq,
                value: values?.loadStatus,
                valueDisplay: values?.loadStatus
            }))
        }

        if (values?.createDate?.from) {
            filters.push(getRule({
                name: "ax_createdatetime",
                nameDisplay: "Created Date",
                operator: filterOperatorTypes.moreThanEq,
                value: values?.createDate?.from.format("YYYY-MM-DD"),
                valueDisplay: values?.createDate?.from.format("YYYY-MM-DD")
            }))
        }

        if (values?.createDate?.to) {
            filters.push(getRule({
                name: "ax_createdatetime",
                nameDisplay: "Created Date",
                operator: filterOperatorTypes.lessThanEq,
                value: values?.createDate?.to.format("YYYY-MM-DD"),
                valueDisplay: values?.createDate?.to.format("YYYY-MM-DD")
            }))
        }

        if (values?.checkInDate?.from) {
            filters.push(getRule({
                name: productInjectionFields.checkinDateTime.retrieveKey,
                nameDisplay: "Checked In Date",
                operator: filterOperatorTypes.moreThanEq,
                value: values?.checkInDate?.from.format("YYYY-MM-DD"),
                valueDisplay: values?.checkInDate?.from.format("YYYY-MM-DD")
            }))
        }

        if (values?.checkInDate?.to) {
            filters.push(getRule({
                name: productInjectionFields.checkinDateTime.retrieveKey,
                nameDisplay: "Checked In Date",
                operator: filterOperatorTypes.lessThanEq,
                value: values?.checkInDate?.to.format("YYYY-MM-DD"),
                valueDisplay: values?.checkInDate?.to.format("YYYY-MM-DD")
            }))
        }

        // console.log('filters', filters)

        dispatch({ type: actionTypes.updateAllRules, payload: filters })
        dispatch({ type: actionTypes.updateColumns, payload: columns })
        closeCustomDrawer();

    }

    const RenderMain = () => {

        return (
            <form
                onSubmit={handleSubmit}
                style={{
                    height: '100%',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'space-between',
                        height: '100%'
                        // alignItems: 'center'
                    }}
                >
                    {/* {JSON.stringify(values)} */}
                    {
                        RenderMainForm()
                    }

                    {/* <Divider sx={{ mt: 1, mb: 1 }} /> */}

                    <Button
                        type="submit"
                        // fullWidth
                        variant="contained"
                        sx={{
                            m: 2
                        }}
                    // loading={isLoading}
                    // onClick={handleApply}
                    >
                        {t('applyFilters')}
                    </Button>

                </Box>

            </form>
        )
    }

    return (
        <Box
            sx={{
                // flex: 1,
                height: '100%',
            }}
        >
            {
                RenderMain()
            }

            {/* <Button
                onClick={() => {
                    console.log('sdfdsfds')
                    dispatch({ type: actionTypes.addRule, payload: { aaa: 1111 } })
                }}
            >
                Add Rule
            </Button>

            <Button
                onClick={() => {
                    console.log('22222')
                    // dispatch({ type: actionTypes.showFilter, payload: { status: false } })
                    closeCustomDrawer()
                }}
            >
                Close it
            </Button> */}

        </Box>
    )
}